import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import SelectVehicle from './Vehicle'

function AutoModels({ passData, ...props }) {
  const { isIdle, isLoading, error, data } = useQuery(
    ['autoModels', passData.veh_year, passData.veh_make],
    () =>
      axios
        .get(
          `https://rwzqgyxmfd.execute-api.us-east-1.amazonaws.com/prod/v1/models?year=${passData.veh_year}&make=${passData.veh_make}`,
        )
        .then((res) => res.data),
    {
      enabled: !!passData?.veh_year && !!passData?.veh_make,
    },
  )

  if (isIdle || isLoading) return 'Loading...'

  if (error) return 'An error has occurred: ' + error.message

  const options = data.data.map(({ model }) => ({ placeholder: model, value: model }))

  return (
    <div>
      <SelectVehicle {...props} options={options} />
    </div>
  )
}

export default AutoModels
